import { CONTROL_TEXT_CLASS } from "../lib/ui.js";

export default function ControlGroup({ items, activeValue, onSelect, kind = "pill", className = "" }) {
  return (
    <div className={["flex flex-wrap gap-1", className].filter(Boolean).join(" ")}>
      {items.map(([value, label]) => (
        <button
          key={value}
          type="button"
          className={[
            // Opaque --bg base so the button reads as solid on
            // dotted-pattern surfaces (Sheet diagram bg). Same visual
            // on plain --bg hosts since transparent over --bg and
            // --bg over --bg both paint the same color.
            //
            // Active state layers --green-soft as a background-image
            // over the --bg base (rather than replacing it via
            // bg-color), so the translucent green also composites
            // onto solid bg instead of the dotted pattern.
            "inline-flex min-h-[28px] flex-none items-center justify-center whitespace-nowrap rounded-[2px] border border-[color:var(--line)] bg-[color:var(--bg)] px-[9px]",
            value === activeValue
              ? "border-[rgba(142,191,77,0.5)] [background-image:linear-gradient(var(--green-soft),var(--green-soft))] text-[color:var(--ink)]"
              : "",
            kind === "tab" ? "" : "",
          ]
            .filter(Boolean)
            .join(" ")}
          onClick={() => onSelect(value)}
        >
          <span className={CONTROL_TEXT_CLASS}>{label}</span>
        </button>
      ))}
    </div>
  );
}
